import { genericRoute } from 'utils/routeUtils';

import NFLHomePage from './containers/NFLHomePage';
import NFLNav from './nav/NFLNav';

export default genericRoute(NFLHomePage, NFLNav, 'nfl');



// WEBPACK FOOTER //
// ./modules/NFL/routes.js